export const ADD_ALL_CINEMAS = 'ADD_ALL_CINEMAS';
export const FETCH_ALL_CINEMAS = 'FETCH_ALL_CINEMAS';
export const SET_SELECTED_CINEMA = 'SET_SELECTED_CINEMA';
export const ADVERTISE_PDF_DATA = 'ADVERTISE_PDF_DATA';
